<template>
  <div>
    <div class="bi" @click="goBI" v-if="hasStatPermission">
      <a-tooltip placement="bottom">
        <template slot="title">
          <span>教学统计</span>
        </template>
        <img src="@/assets/icons/icon_states.png" alt="" />
      </a-tooltip>
    </div>
    <div class="message" v-if="hasIdeaPermission" @click="goMessage">
      <img src="@/assets/icons/icon_message.png" alt="" />
      <span v-if="unReadCount != 0">{{ unReadCount }}</span>
    </div>
    <a-popover
      class=" protal"
      placement="bottom"
      overlayClassName="user-ant-popover"
      @visibleChange="dropdownChange"
      v-if="(userRoles && userRoles.indexOf('admin') > -1) || hasProtal"
    >
      <div class="ant-pro-account-avatar">
        <img v-if="!skipVisible" src="@/assets/icons/icon_mh.png" alt="" />
        <img v-else src="@/assets/icons/icon_mh_hover.png" alt="" />
        <img v-if="!skipVisible" class="down" src="@/assets/icons/icon_j.png" alt="" srcset="" />
        <img v-else class="down" src="@/assets/icons/icon_j_hover.png" alt="" srcset="" />
      </div>
      <template slot="content">
        <a-menu class="user-dropdown" @click="() => (skipVisible = false)">
          <a-menu-item @click="goProtal" v-if="hasProtal">
            门户首页
          </a-menu-item>
          <a-menu-item v-if="userRoles && userRoles.indexOf('admin') > -1" @click="changeType">
            {{ isAdmin ? '教学平台' : '管理后台' }}
          </a-menu-item>
        </a-menu>
      </template>
    </a-popover>
    <a-popover overlayClassName="user-ant-popover" placement="bottom" v-if="currentUser && currentUser.name">
      <div class="ant-pro-account-avatar">
        <img
          class="user-logo"
          :src="currentUser.avatar ? currentUser.avatar : require('@/assets/icons/icon_m.png')"
          alt=""
          srcset=""
        />
        <span style="color: #000;">{{ currentUser.name ? currentUser.name : 'admin' }}</span>
        <img class="down" src="@/assets/icons/icon_j.png" alt="" srcset="" />
      </div>
      <template slot="content">
        <a-menu class="user-dropdown" :class="isAdmin ? 'admin' : ''">
          <a-menu-item @click="personalInfo"> 个人中心 </a-menu-item>
          <a-menu-item @click="passwordChange"> 密码设置 </a-menu-item>
          <a-menu-item v-if="!isAdmin" @click="aboutModal"> 关于我们 </a-menu-item>
          <a-menu-item @click="loginout"> 退出登录 </a-menu-item>
        </a-menu>
      </template>
    </a-popover>
    <span v-else>
      <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
    </span>
    <a-modal
      title="修改密码"
      :visible="passwordModal"
      :confirm-loading="passwordConfirmLoading"
      @ok="handleSubmit"
      @cancel="passwordModal = false"
    >
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="旧密码" :colon="false">
          <a-input
            v-decorator="[
              'passwordOld',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入旧密码！'
                  }
                ]
              }
            ]"
            :type="!oldpasswordFlag ? 'password' : 'text'"
            placeholder="请输入旧密码！"
          >
            <img
              @click="oldpasswordFlag = true"
              v-if="!oldpasswordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="oldpasswordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
        <a-form-item label="新密码" :colon="false">
          <a-input
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    pattern: /^[A-Za-z0-9]{8,13}$/,
                    message: '请输入8-13位的数字或大小写字母'
                  }
                ]
              }
            ]"
            :type="!passwordFlag ? 'password' : 'text'"
            placeholder="支持数字、大小写字母、8-13位"
          >
            <img
              @click="passwordFlag = true"
              v-if="!passwordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="passwordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
        <a-form-item label="确认密码" :colon="false">
          <a-input
            v-decorator="[
              'confirmPassword',
              {
                rules: [
                  {
                    required: true,
                    message: '请再次输入密码'
                  },
                  {
                    validator: compareToFirstPassword
                  }
                ]
              }
            ]"
            :type="!repasswordFlag ? 'password' : 'text'"
            @blur="handleConfirmBlur"
            placeholder="请再次输入密码"
          >
            <img
              @click="repasswordFlag = true"
              v-if="!repasswordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="repasswordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
      </a-form>
    </a-modal>
    <About :visible="aboutVisible" @cancel="aboutVisible = false" />
    <!-- 用户反馈 -->
    <IdeaAdd v-if="hasIdeaPermission" :menuData="menuData"></IdeaAdd>
  </div>
</template>

<script>
import md5 from 'md5'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { mapState } from 'vuex'
import cookie from 'js-cookie'
import { teacherChangePassword, columnStatus } from '@/api/admin'
import { studentPassword, externalUserChangePwd } from '@/api/index'
import { unReadCountGet } from '@/api/message'
import TipModal from '@/components/tipModal/index.vue'
import About from './About.vue'
import IdeaAdd from '@/views/message/idea/add.vue'

export default {
  name: 'AvatarDropdown',
  components: {
    TipModal,
    About,
    IdeaAdd
  },
  props: {
    currentUser: {
      type: Object,
      default: () => null
    },
    menu: {
      type: Boolean,
      default: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    menuData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      unReadCount: state => {
        return state.app.unReadCount
      }
    }),
    hasInfoPermission() {
      return !this.isAdmin && (this.hasPermission('school_class_manage') || this.hasPermission('student_info'))
    },
    hasStatPermission() {
      return !this.isAdmin && this.hasPermission('teacher_teaching_statistics')
    },
    hasIdeaPermission() {
      return (
        !this.isAdmin && (this.hasPermission('teacher_feedback_menu') || this.hasPermission('student_feedback_menu'))
      )
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'register' })
  },
  mounted() {
    this.getUnReadCount()
    this.getColumnState()
    this.permissionList = localStorage.permissionList || []
  },
  watch: {
    $route(to, from) {
      this.getColumnState()
      this.getUnReadCount()
    }
  },
  data() {
    return {
      passwordFlag: false,
      passwordModal: false,
      repasswordFlag: false,
      oldpasswordFlag: false,
      noPermissionModal: false,
      passwordConfirmLoading: false,
      aboutVisible: false,
      userRoles: cookie.getJSON('user_type', {
        domain: '.' + location.hostname
      }),
      hasProtal: false,
      skipVisible: false
    }
  },
  methods: {
    hasPermission(tag) {
      const permissionList = localStorage.permissionList || '[]'
      return permissionList && permissionList.includes(tag)
    },
    async getUnReadCount() {
      const res = await unReadCountGet()
      const unReadCountDom = res.data.totalCount > 99 ? '99+' : res.data.totalCount
      this.$store.commit('setUnReadCount', unReadCountDom)
    },
    changeType() {
      this.$router.push({
        path: '/',
        query: {
          isAdmin: this.isAdmin ? '0' : '1'
        }
      })
    },
    isPasswordChange() {
      const editPassword = this.$route.query.editPassword
      if (editPassword === '1') {
        this.passwordChange()
      }
    },
    passwordChange() {
      this.passwordModal = true
      this.form.resetFields()
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        const aa = '两次密码输入的不一致！'
        callback(aa)
      } else {
        callback()
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const userType = cookie.getJSON('user_type').join(',')
          const data = {
            id: this.currentUser.id,
            oldPassword: md5(values.passwordOld),
            newPassword: md5(values.password)
          }
          if (userType.includes('external')) {
            const res = await externalUserChangePwd(data)
            if (res.code !== 200) return
          } else {
            if (this.isStudent()) {
              const res = await studentPassword(data)
              if (res.code !== 200) return
            } else {
              const res = await teacherChangePassword(data)
              if (res.code !== 200) return
            }
          }
          this.passwordModal = false
          this.$message.success('登录密码已更新！')
          setTimeout(() => {
            this.loginout()
          }, 1000)
        }
      })
    },
    loginout() {
      cookie.remove(ACCESS_TOKEN)
      cookie.remove(ACCESS_TOKEN, {
        domain: '.' + location.hostname
      })
      cookie.remove('user_type')
      cookie.remove('user_type', {
        domain: '.' + location.hostname
      })
      cookie.remove('user_infor')
      cookie.remove('user_infor', {
        domain: '.' + location.hostname
      })
      window.location.reload()
    },
    aboutModal() {
      this.aboutVisible = true
    },
    isStudent() {
      return cookie
        .getJSON('user_type')
        .join(',')
        .includes('student')
    },
    personalInfo() {
      const permissionList = localStorage.permissionList
      // if (!permissionList.includes('school_class')) return this.$message.error('暂无权限')
      this.$router.push({
        name: 'personal',
        query: {
          role: this.isStudent() ? 'student' : 'teacher'
        }
      })
    },
    async getColumnState() {
      const res = await columnStatus()
      this.hasProtal = res.data.status === 1 && res.data.hasPermission
      this.protalUtl = 'https://' + res.data.customDomainPrefix + '.' + location.hostname
    },
    goMessage() {
      this.$router.push({ name: 'messageIndex' })
    },
    goProtal() {
      window.open(this.protalUtl)
    },
    dropdownChange(flag) {
      this.skipVisible = flag
    },
    goBI() {
      this.$router.push({
        name: 'teachingStats'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.message {
  width: 26px;
  height: 26px;
  position: relative;
  margin-right: 14px;
  margin-bottom: 21px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    top: 2px;
    left: 15px;
    padding: 0 2px;
    height: 8px;
    background: #ff5700;
    border-radius: 4px;
    font-weight: 500;
    font-size: 8px;
    color: #ffffff;
    line-height: 8px;
  }
}
.bi {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  margin-bottom: 21px;
  width: 26px;
  height: 26px;
  img {
    width: 100%;
    height: 100%;
  }
  i {
    font-size: 17px;
    color: #adbbd0;
  }
  &:hover {
    cursor: pointer;
    i {
      color: #f06321;
    }
  }
}
.protal {
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    width: 1px;
    height: 12px;
    background: #c9c9c9;
    margin: 0 12px;
  }
  img {
    width: 26px;
  }
  span {
    font-size: 12px;
    color: #000000;
  }
  &:hover {
    // img{
    //   transform: translateY(-60px);
    //   filter: drop-shadow(#FF6000 0 60px);
    // }
    // span{
    //   color: #FF6000;
    // }
  }
}

.ant-dropdown.ant-dropdown-placement-bottomRight {
  left: auto !important;
  right: 10px !important;
  min-width: 150px !important;
  top: 0 !important;
}

.ant-pro-account-avatar {
  // width: 200px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 21px;
  justify-content: flex-end;
  .user-logo {
    width: 26px;
    height: 26px;
    margin-right: 12px;
    border-radius: 100%;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/ .user-dropdown {
  left: auto !important;
  width: 110px !important;
  box-shadow: none;
  padding-top: 15px;
  // background: url('~@/assets/img/bj_tc.png') no-repeat;
  background-size: 100% 100%;
  background-position: center;
  .ant-dropdown-menu-item {
    background: none;
    color: #ffffff;
    padding: 8px 0;
    margin: 0 5px;
    font-weight: 550;
    text-align: center;
    border-bottom: 1px solid #525354;
    &:hover {
      color: #f5a623;
    }
    &:last-child {
      border: 0;
    }
  }
}
/deep/ .skip-ant-dropdown {
  top: 45px !important;
  right: 150px !important;
  left: auto !important;
}
/deep/.ant-dropdown.ant-dropdown-placement-bottomLeft,
.skip-dropdown {
  width: 110px !important;
  box-shadow: none;
  padding-top: 15px;
  // background: url('~@/assets/img/bj_tc.png') no-repeat;
  background-size: 100% 100%;
  background-position: center;
  .ant-dropdown-menu-item {
    background: none;
    color: #ffffff;
    padding: 8px 0;
    margin: 0 5px;
    font-weight: 550;
    text-align: center;
    border-bottom: 1px solid #525354;
    &:hover {
      color: #f5a623;
    }
    &:last-child {
      border: 0;
    }
  }
}
/deep/.ant-form {
  .ant-form-item {
    margin-bottom: 22px;
    .ant-form-item-label {
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
// .user-ant-dropdown{
//   top: auto !important;
//   left: auto !important;
//   right: 0 !important;
// }
.user-ant-popover {
  width: 110px !important;
  box-shadow: none;
  // background: url('~@/assets/img/bj_tc.png') no-repeat;
  background-size: 100% 100%;
  background-position: center;
  .ant-popover-content {
    .ant-popover-arrow {
      border-color: #45484a !important;
    }
  }
  .ant-popover-inner-content {
    background: #45484a;
    border-radius: 5px;
    overflow: hidden;
  }
  .ant-menu {
    border: none;
    background: #45484a;
    .ant-menu-item-selected {
      background: #45484a !important;
    }
    .ant-menu-item {
      background: none;
      color: #ffffff;
      padding: 0 !important;
      margin: 0 !important;
      font-weight: 550;
      text-align: center;
      border-bottom: 1px solid #525354;
      &:hover {
        color: #f5a623;
      }
      &:last-child {
        border: 0;
      }
    }
  }
}
div .ant-table-thead > tr > th,
td {
  text-align: center;
}
td > div {
  margin: 0 auto;
}
td .operate > span:last-child {
  margin-right: 0;
}
.ant-dropdown.ant-dropdown-placement-bottomLeft.user-ant-dropdown {
  min-width: 110px !important;
  top: 55px !important;
  right: 20px !important;
  left: auto !important;
}
.ant-dropdown.ant-dropdown-placement-bottomLeft.skip-ant-dropdown {
  min-width: 110px !important;
  top: 55px !important;
  right: 140px !important;
  left: auto !important;
}
</style>
